import React from 'react';
import Header from './components/Header';
import BannerParallax from './components/BannerParallax';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ProjectsSection from './components/ProjectsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import LogoDivider from './components/LogoDivider';

const ABC: React.FC = () => {
  return (
    <>
      <div className='w-full min-h-screen bg-white text-neutral-900'>
        <Header />
        <BannerParallax />
        <AboutSection />
        <ServicesSection />
        <LogoDivider />
        <ProjectsSection />
        <ContactSection />
        <Footer />
      </div>
    </>
  );
};

export default ABC;
